// Shared helpers for the night-sort peak availability map (sorter portal tab + admin view).
// The nights themselves are built server-side (peak-availability-sb.js buildNights).

export const PEAK_FN = '/.netlify/functions/peak-availability-sb';

export function peakCall(action, payload = {}) {
  return fetch(PEAK_FN, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
    body: JSON.stringify({ action, ...payload }),
  }).then((r) => r.json().then((d) => ({ status: r.status, ...d })));
}

const at = (iso) => new Date(iso + 'T12:00:00');
export const fmtNight = (iso) => at(iso).toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
export const fmtLong = (iso) => at(iso).toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long' });
export const fmtStamp = (ts) => { try { return new Date(ts).toLocaleString('en-AU', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }); } catch { return ts; } };

// A night is labelled by the day it starts, and a peak night also says which delivery
// it serves, because "the Saturday" is how everyone talks about the Friday-night sort.
export const nightLabel = (n) => n.peak ? `${fmtNight(n.date)} night · Saturday run (${fmtNight(n.delivery)})` : `${fmtNight(n.date)} night`;

// Month grids (Mon-first) covering the nights, each cell { iso, day, night|null } or null.
export function monthGrids(nights) {
  if (!nights || !nights.length) return [];
  const byDate = new Map(nights.map((n) => [n.date, n]));
  const first = at(nights[0].date), last = at(nights[nights.length - 1].date);
  const out = [];
  const end = last.getFullYear() * 12 + last.getMonth();
  for (let k = first.getFullYear() * 12 + first.getMonth(); k <= end; k++) {
    const y = Math.floor(k / 12), m = k % 12;
    const lead = (new Date(y, m, 1).getDay() + 6) % 7;
    const days = new Date(y, m + 1, 0).getDate();
    const cells = Array(lead).fill(null);
    for (let d = 1; d <= days; d++) {
      const iso = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      cells.push({ iso, day: d, night: byDate.get(iso) || null });
    }
    while (cells.length % 7) cells.push(null);
    out.push({ key: `${y}-${m}`, title: new Date(y, m, 1).toLocaleDateString('en-AU', { month: 'long', year: 'numeric' }), cells });
  }
  return out;
}

export const WEEK_HEAD = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Deadline passed? The deadline day itself still counts (Sydney date strings compare as text).
export const pastDeadline = (survey, today) => !!(survey && survey.deadline && today && today > survey.deadline);
